/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_Install_DescriptionInputs */

const fr_rooms_install_description = /** @type {(inputs: Rooms_Install_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un bloc à coller par chambre configurée.`)
};

const en_rooms_install_description = /** @type {(inputs: Rooms_Install_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One snippet to paste per configured room.`)
};

/**
* | output |
* | --- |
* | "One snippet to paste per configured room." |
*
* @param {Rooms_Install_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const rooms_install_description = /** @type {((inputs?: Rooms_Install_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_Install_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_rooms_install_description(inputs)
	return en_rooms_install_description(inputs)
});